<template>
  <v-container v-if="!requireOnlyItems" grid-list-md
    id="clientFiler"
    class="filer py-0"
    @dragover.prevent="dragover"
    @dragleave.prevent="dragleave"
    @drop.stop.prevent="drop"
    @dragend.stop.prevent="dragend">
    <v-row dense>
      <v-col cols="12">
        <v-card flat color="transparent">
          <cli-filer-toolbar ref="toolbar"
            :lib="getLibrary"
            :status="getStatus"
            :fixed="!!$props.fixedRoot"
            @emit="emitted"
          />
          <cli-filer-header  v-if="$vuetify.breakpoint.smAndUp"
            :order="this.form.order"
            @emit="emitted"
          />
          <v-list :class="['items', 'pa-0', { dropping: isDropping }]">
            <v-progress-linear indeterminate class="ma-0" :color="isLoading ? 'blue' : 'transparent'"></v-progress-linear>
            <template v-for="(item, idx) in getItems">
              <v-divider v-if="idx !== 0" :key="item.id + '_div'"></v-divider>
              <FilerFile v-if="item.type === 'file'"
                :ref="`item_${form.order.field}_${form.order.dir}`"
                :key="item.id"
                :cid="getClientId"
                :authed="$refs.toolbar.isAuthed && !$refs.toolbar.isRootShared"
                :shared="$refs.toolbar.hasSharedDirectory"
                :trashed="$refs.toolbar.isTrashed"
                :status="getStatus"
                :item="item"
                :selectable="$props.selectable == null || $props.selectable"
                @emit="emitted"
              />
              <FilerFolder v-else-if="item.type === 'folder'"
                :ref="`item_${form.order.field}_${form.order.dir}`"
                :key="item.id"
                :cid="getClientId"
                :authed="$refs.toolbar.isAuthed && !$refs.toolbar.isRootShared"
                :shared="$refs.toolbar.hasSharedDirectory"
                :trashed="$refs.toolbar.isTrashed"
                :status="getStatus"
                :item="item"
                :selectable="$props.selectable == null || $props.selectable"
                @emit="emitted"
              />
            </template>
            <v-list-item v-if="getItems.length === 0 && !isSimple && !isLoading" class="grey--text text--darken-2">このフォルダは空です</v-list-item>
          </v-list>
          <v-bottom-sheet :value="isDropping" hide-overlay>
            <v-list :class="isLocked ? 'red white--text' : 'blue darken-2 white--text'">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="white--text">{{ isLocked ? 'このフォルダにはアップロードできません。' : 'ファイルをドロップしてアップロードできます。'}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-bottom-sheet>
        </v-card>
      </v-col>
    </v-row>
    <div class="ghost body-1 blue white--text pa-2" ref="ghost">{{ printGhost }}</div>
    <RenameModal ref="renamer" @emit="emitted"></RenameModal>
    <PreviewModal ref="previewer" @emit="emitted"></PreviewModal>
    <MkdirModal ref="mkdirer" @emit="emitted"></MkdirModal>
    <ShareModal ref="sharer" @emit="emitted" />
    <ConfirmModal ref="confirmer" @emit="emitted"></ConfirmModal>
  </v-container>
  <v-list v-else :class="['items', { dropping: isDropping }]" style="width:100%;">
    <v-progress-linear v-if="isLoading" class="ma-0" indeterminate color="blue"></v-progress-linear>
    <template v-for="(item, idx) in getItems">
      <v-divider v-if="idx !== 0" :key="item.id + '_div'"></v-divider>
      <FilerFile v-if="item.type === 'file'"
        :ref="`item_${form.order.field}_${form.order.dir}`"
        :key="item.id"
        :cid="getClientId"
        :authed="$props.authed"
        :shared="$props.shared"
        :trashed="$props.trashed"
        :status="getStatus"
        :item="item"
        @emit="emitted"
      />
      <FilerFolder v-if="item.type === 'folder'"
        :ref="`item_${form.order.field}_${form.order.dir}`"
        :key="item.id"
        :cid="getClientId"
        :authed="$props.authed"
        :shared="$props.shared"
        :trashed="$props.trashed"
        :status="getStatus"
        :item="item"
        @emit="emitted"
      />
    </template>
    <v-list-item v-if="getItems.length === 0 && !isLoading" class="grey--text text--darken-2">何のアイテムもありません</v-list-item>
    <RenameModal ref="renamer" @emit="emitted" />
    <PreviewModal ref="previewer" @emit="emitted" @closed="$emit('previewed')" />
    <MkdirModal ref="mkdirer" @emit="emitted" />
    <ShareModal ref="sharer" @emit="emitted" />
    <ConfirmModal ref="confirmer" @emit="emitted" />
  </v-list>
</template>

<script>
import CliFilerToolbar from './toolbar'
import CliFilerHeader from './header'
import FilerFolder from '../components/folder'
import FilerFile from '../components/file'
import RenameModal from '../components/modals/rename'
import PreviewModal from '../components/modals/preview'
import MkdirModal from '../components/modals/mkdir'
import ShareModal from '../components/modals/share'
import ConfirmModal from '@/components/modals/confirm'
const DEF = {
  STATUS: {
    PERSONAL: false,
    LOADING: false,
    DRAGGING: false,
    DROPPING: false,
    LOCKED: false,
    CD: null,
    PERMITS: JSON.stringify({
      add: true,
      modify: true,
      trash: true,
      root: false,
      select: true
    })
  },
  FORM: {
    ORDER: {
      FIELD: 'name',
      DIR: 'asc'
    }
  }
}
export default {
  name: 'clientFiler',
  components: {
    CliFilerToolbar,
    CliFilerHeader,
    FilerFolder,
    FilerFile,
    RenameModal,
    PreviewModal,
    MkdirModal,
    ShareModal,
    ConfirmModal
  },
  props: [
    'cid',
    'rid',
    'authed',
    'items',
    'filters',
    'permits',
    'fixedRoot',
    'showOnlyItems'
  ],
  data () {
    return {
      config: {
        status: {
          loading: DEF.STATUS.LOADING,
          dragging: DEF.STATUS.DRAGGING,
          dropping: DEF.STATUS.DROPPING,
          locked: DEF.STATUS.LOCKED,
          permits: {}
        }
      },
      meta: {
        status: {
          media: {
            adding: true,
            modifying: true,
            trash: true,
            copying: ''
          },
          trash: {
            adding: false,
            modifying: false,
            trash: false,
            copying: ''
          },
          arrange: {
            adding: false,
            modifying: false,
            trash: true,
            copying: ''
          }
        }
      },
      form: {
        order: {
          field: DEF.FORM.ORDER.FIELD,
          dir: DEF.FORM.ORDER.DIR
        }
      },
      store: {
        lib: {},
        items: [],
        ghost: ''
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    init: function (req) {
      const { type, cid, rid, permits, showOnlyItems } = req || this.$props || {}
      if (!showOnlyItems && (cid || rid || type === 'shared')) {
        this.$set(this.config.status, 'loading', true)
        this.$set(this.store, 'items', [])
        this.get({
          id: rid || cid || -1,
          type: type || (rid ? 'folder' : 'client'),
          tags: {
            authed: this.$props.authed
          }
        })
        this.$set(this.config.status, 'permits', Object.assign(JSON.parse(DEF.STATUS.PERMITS), permits))
      }
      if (this.$refs.toolbar) {
        this.$refs.toolbar.init()
      }
    },
    emitted: function (req) {
      const { action, data } = req || {}
      if (action && typeof this[action] === 'function') {
        this[action](data)
      }
    },
    open: function (item) {
      const { type } = item || {}
      if (type) {
        if (type === 'file') {
          this.$refs.previewer.open(item)
          this.$emit('preview')
        } else if (type === 'folder') {
          this.get(item)
        }
      }
    },
    trash: function (item) {
      const { id, name, type } = item || {}
      const cid = this.$props.cid || this.$route.params.id || ''
      if (id && name && type && cid) {
        const nameInfo = name.split('.')
        const ext = (nameInfo.length > 1) ? nameInfo.pop() : ''
        const fileName = nameInfo.join('.')
        const pid = this.$refs.toolbar.getCurrentDir().id
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(`${this.$url.api}box/trash/${cid}/${id}`, {
            type, name: fileName, ext, pid
          }, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              let idx = this.store.items.findIndex(it => {
                return it.id === id
              })
              if (idx >= 0) {
                this.store.items.splice(idx, 1)
              }
            }
          }).catch(err => {
            console.log(err)
          })
        })
      }
    },
    restore: function (item) {
      const { id, name, type } = item || {}
      const cid = this.$props.cid || this.$route.params.id || ''
      if (id && name && type && cid) {
        let nameInfo = name.split('.')
        let ext = (nameInfo.length > 1) ? nameInfo.pop() : ''
        let fileName = nameInfo.join('.')
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(`${this.$url.api}box/restore/${cid}/${id}`, {
            type, name: fileName, ext
          }, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              let idx = this.store.items.findIndex(it => {
                return it.id === id
              })
              if (idx >= 0) {
                this.store.items.splice(idx, 1)
              }
            }
          }).catch(err => {
            console.log(err)
          })
        })
      }
    },
    share: function (req) {
      const { id } = req || {}
      const { cid } = this.$props || {}
      if (id && cid) {
        const idx = this.$props.items ? this.$props.items.findIndex(it => { return it.id === id }) : this.store.items.findIndex(it => { return it.id === id })
        if (idx >= 0) {
          const item = this.$props.items ? this.$props.items[idx] : this.store.items[idx]
          this.$refs.sharer.open({
            cid: cid,
            item: item
          })
        }
      }
    },
    shared: function (item) {
      const { id } = item || {}
      const slug = `item_${this.form.order.field}_${this.form.order.dir}`
      if (id) {
        const sidx = this.store.items.findIndex(it => { return it.id === item.id })
        const ridx = this.$refs[slug].findIndex(it => { return it.item.id === item.id })
        if (sidx >= 0) {
          this.store.items.splice(sidx, 1, item)
        }
        if (ridx >= 0) {
          this.$refs[slug][ridx].state({
            type: 'loading',
            status: false
          })
        }
      }
    },
    unshare: function (item) {
      const { id } = item || {}
      const { cid } = this.$props || {}
      const slug = `item_${this.form.order.field}_${this.form.order.dir}`
      if (id && cid) {
        const idx = this.store.items.findIndex(it => { return it.id === item.id })
        if (idx >= 0) {
          const { id, name, type, tags } = this.store.items[idx]
          this.$refs.confirmer.open({
            title: 'アイテムの共有解除',
            message: `${name}の共有を止めてもよろしいですか？`,
            callback: () => {
              const jdx = this.$refs[slug].findIndex(it => { return it.item.id === item.id })
              if (jdx >= 0) {
                this.$refs[slug][jdx].state({
                  type: 'loading',
                  status: true
                })
                this.$firebase.auth().currentUser.getIdToken(true).then(token => {
                  this.axios.post(`${this.$url.api}box/unshare/${this.$props.cid}`, {
                    mid: id,
                    type: type,
                    tags: tags
                  }, {
                    headers: {
                      'firebase-token': token
                    }
                  }).then(res => {
                    console.log(res)
                    if (res.data && res.data.success) {
                      if (this.$refs.toolbar.isRootShared) {
                        this.store.items.splice(idx, 1)
                      } else {
                        this.$set(this.store.items[idx], 'tags', this.store.items[idx].tags.filter(tag => { return tag !== 'shared' }))
                        this.$refs[slug][jdx].state({
                          type: 'loading',
                          status: false
                        })
                      }
                    }
                  }).catch(err => {
                    console.log(err)
                  })
                })
              }
            }
          })
        }
      }
    },
    get: function (dest) {
      const urls = {
        shared: `${this.$url.api}box/get/shared/${this.$props.cid}`,
        folder: `${this.$url.api}box/get/client/folder/${dest.id}`,
        client: `${this.$url.api}box/get/client/${dest.id}`
      }
      if (dest && dest.type) {
        const url = urls[dest.type] || urls.folder
        this.$set(this.config.status, 'loading', true)
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(url, {
            options: this.form
          }, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.$set(this.store, 'items', res.data.data)
              if (this.$refs.toolbar) {
                this.$refs.toolbar.forward(dest)
              }
            }
            this.$set(this.config.status, 'loading', false)
          }).catch(err => {
            console.log(err)
          })
          if (this.$props.cid) {
            this.axios.post(`${this.$url.api}box/get/root/${this.$props.cid}`, {
            }, {
              headers: {
                'firebase-token': token
              }
            }).then(res => {
              console.log(res)
              if (res.data && res.data.success) {
                this.$set(this.store, 'lib', res.data.data)
              }
            }).catch(err => {
              console.log(err)
            })
          }
        })
      }
    },
    orderBy: function (field) {
      if (field) {
        if (this.form.order.field === field) {
          this.$set(this.form.order, 'dir', (this.form.order.dir === 'asc') ? 'desc' : 'asc')
        } else {
          this.$set(this.form.order, 'field', field)
        }
      }
    },
    upload: function (files) {
      const dest = this.$refs.toolbar.getCurrentDir()
      const authed = this.$refs.toolbar.isAuthed
      this.$set(this.config.status, 'dropping', false)
      if (authed && files && files.length) {
        if (dest && dest.id) {
          for (let i = 0; i < files.length; i++) {
            let f = files[i]
            let nid = new Date().getTime().toString(16) + Math.floor(1000 * Math.random()).toString(16)
            let fd = new FormData()
            fd.append('file', f)
            this.$store.dispatch('notifier/addProgress', {
              id: nid,
              title: 'アップロード中... 0%',
              message: f.name,
              progress: 0.001
            })
            this.$firebase.auth().currentUser.getIdToken(true).then(token => {
              this.axios.post(this.$url.api + 'box/upload/' + dest.id, fd, {
                headers: {
                  'content-type': 'multipart/form-data',
                  'firebase-token': token
                },
                onUploadProgress: (e) => {
                  let per = e.loaded / e.total
                  this.$store.dispatch('notifier/updateProgress', {
                    id: nid,
                    title: 'アップロード中... ' + Math.round(per * 100) + '%',
                    progress: per
                  })
                }
              }).then(res => {
                console.log(res)
                if (res.data && res.data.success) {
                  if (
                    res.data.data &&
                    res.data.data.parent &&
                    res.data.data.parent.id &&
                    res.data.data.parent.id === dest.id
                  ) {
                    this.store.items.push(res.data.data)
                  }
                  this.$store.dispatch('notifier/doneProgress', {
                    id: nid,
                    type: 'success',
                    title: 'アップロード完了',
                    message: f.name,
                    progress: 0
                  })
                } else if (
                  res.data &&
                  res.data.data &&
                  res.data.data.response &&
                  res.data.data.response.body &&
                  res.data.data.response.body.code
                ) {
                  let code = res.data.data.response.body.code
                  let err = this.$error.box.file.upload[code] ? this.$error.box.file.upload[code] : ''
                  if (err) {
                    this.$store.dispatch('notifier/doneProgress', {
                      id: nid,
                      type: 'error',
                      title: 'アップロード失敗',
                      message: err
                    })
                  }
                }
              })
            })
          }
        }
      }
    },
    replace: function (req) {
      const { dest, file } = req
      const authed = this.$refs.toolbar.isAuthed
      if (authed && dest && dest.id && file) {
        const idx = this.store.items.findIndex(it => { return it.id === dest.id })
        if (idx >= 0) {
          const nid = new Date().getTime().toString(16) + Math.floor(1000 * Math.random()).toString(16)
          const fd = new FormData()
          fd.append('file', file)
          fd.append('tags', this.store.items[idx].tags)
          this.$store.dispatch('notifier/addProgress', {
            id: nid,
            title: 'アップロード中... 0%',
            message: file.name,
            progress: 0.001
          })
          this.$firebase.auth().currentUser.getIdToken(true).then(token => {
            this.axios.post(`${this.$url.api}box/replace/${dest.id}`, fd, {
              headers: {
                'content-type': 'multipart/form-data',
                'firebase-token': token
              },
              onUploadProgress: (e) => {
                let per = e.loaded / e.total
                this.$store.dispatch('notifier/updateProgress', {
                  id: nid,
                  title: 'アップロード中... ' + Math.round(per * 100) + '%',
                  progress: per
                })
              }
            }).then(res => {
              console.log(res)
              if (res.data && res.data.success) {
                this.store.items.splice(idx, 1, Object.assign({}, res.data.data, { tags: this.store.items[idx].tags }))
                this.$store.dispatch('notifier/doneProgress', {
                  id: nid,
                  type: 'success',
                  title: 'アップロード完了',
                  message: file.name,
                  progress: 0
                })
              } else if (
                res.data &&
                res.data.data &&
                res.data.data.response &&
                res.data.data.response.body &&
                res.data.data.response.body.code
              ) {
                let code = res.data.data.response.body.code
                let err = this.$error.box.file.upload[code] ? this.$error.box.file.upload[code] : ''
                if (err) {
                  this.$store.dispatch('notifier/doneProgress', {
                    id: nid,
                    type: 'error',
                    title: 'アップロード失敗',
                    message: err
                  })
                }
              }
            })
          })
        }
      }
    },
    move: function (item) {
      const { id, tags } = item || {}
      const slug = `item_${this.form.order.field}_${this.form.order.dir}`
      if (id) {
        const { authed } = tags || {}
        const cd = this.$refs.toolbar.getCurrentDir()
        const isAuthed = !(authed && authed !== this.$store.getters['author/get']('userid')) && this.$refs.toolbar.isAuthed
        if (isAuthed) {
          let items = this.$refs[slug].filter(it => {
            return (
              it.isSelecting &&
              it.item &&
              it.item.id &&
              it.item.type && !(
                it.item.tags &&
                it.item.tags.authed &&
                it.item.tags.authed !== this.$store.getters['author/get']('userid')
              )
            )
          }).map(it => {
            it.state({
              type: 'loading',
              status: true
            })
            return {
              id: it.item.id,
              type: it.item.type
            }
          })
          if (items.length) {
            this.$firebase.auth().currentUser.getIdToken(true).then(token => {
              this.axios.post(`${this.$url.api}box/move/${item.id}`, {
                items: items
              }, {
                headers: {
                  'firebase-token': token
                }
              }).then(res => {
                console.log(res)
                if (res.data && res.data.success) {
                  let ccd = this.$refs.toolbar.getCurrentDir()
                  if (cd.id === ccd.id) {
                    let sids = items.map(it => { return it.id })
                    this.$set(this.store, 'items', this.store.items.filter(it => {
                      return !sids.includes(it.id)
                    }))
                  }
                } else if (
                  res.data &&
                  res.data.data &&
                  res.data.data.response &&
                  res.data.data.response.body &&
                  res.data.data.response.body.code
                ) {
                  let code = res.data.data.response.body.code
                  let err = this.$error.box.item.move[code] ? this.$error.box.item.move[code] : ''
                  if (err) {
                    this.$store.dispatch('notifier/addAlert', {
                      title: 'アイテムの移動失敗',
                      message: err
                    })
                  }
                  let ccd = this.$refs.toolbar.getCurrentDir()
                  if (cd.id === ccd.id) {
                    this.$set(this.store, 'items', [])
                    this.$nextTick(() => {
                      this.get(ccd.id)
                    })
                  }
                }
              })
            })
          }
        } else {
          this.$store.dispatch('notifier/addAlert', {
            title: 'アイテムの移動失敗',
            message: '指定のフォルダへの操作は許可されていません。'
          })
        }
      }
    },
    rename: function (item) {
      if (item) {
        this.$refs.renamer.open(item)
      }
    },
    renamed: function (item) {
      if (item) {
        let idx = this.store.items.findIndex(it => {
          return it.id === item.id
        })
        if (idx >= 0) {
          this.store.items.splice(idx, 1, Object.assign(this.store.items[idx], item))
        }
      }
    },
    mkdir: function (item) {
      this.$refs.mkdirer.open(item)
    },
    mkdired: function (item) {
      if (item && item.id) {
        this.store.items.push(Object.assign({ tags: [] }, item))
      }
    },
    select: function (req) {
      const { item, event } = req || {}
      const slug = `item_${this.form.order.field}_${this.form.order.dir}`
      if (item && event) {
        let sidx = this.$refs[slug].findIndex(it => {
          return (it.item && it.item.id && it.item.id === item.id)
        })
        if (sidx >= 0) {
          if (event.shiftKey) {
            let idx = -1
            let i = sidx + 1
            while (i < this.$refs[slug].length && idx === -1) {
              idx = this.$refs[slug][i].isSelecting ? i : idx
              i += 1
            }
            i = sidx - 1
            while (i >= 0 && idx === -1) {
              idx = this.$refs[slug][i].isSelecting ? i : idx
              i -= 1
            }
            let st = Math.min(sidx, Math.max(idx, 0))
            let ed = Math.max(sidx, idx)
            for (let i = st; i <= ed; i++) {
              if (this.$refs[slug][i].isActive) {
                this.$refs[slug][i].state({
                  type: 'selecting',
                  status: true
                })
              }
            }
          } else if (!event.metaKey) {
            for (let i = 0; i < this.$refs[slug].length; i++) {
              let it = this.$refs[slug][i]
              if (it.item && it.item.id && it.item.id !== item.id) {
                this.$refs[slug][i].state({
                  type: 'selecting',
                  status: false
                })
              }
            }
          }
          let selects = this.$refs[slug].filter(it => {
            return it.isSelecting
          }).map(it => {
            return it.item
          })
          this.setGhost(selects)
          this.$emit('select', selects)
        }
      }
    },
    dragstart: function (e) {
      if (this.config.status.permits.modify) {
        this.$set(this.config.status, 'dragging', true)
        if (this.$refs.ghost) {
          e.dataTransfer.setDragImage(this.$refs.ghost, 20, 20)
        }
      } else {
        e.preventDefault()
      }
    },
    dragend: function () {
      this.$set(this.config.status, 'dragging', false)
      this.$set(this.config.status, 'dropping', false)
    },
    dragover: function () {
      const { status } = this.config
      const cd = this.$refs.toolbar.getCurrentDir()
      const { tags } = cd || {}
      const { authed } = tags || {}
      const isAuthed = !(authed && authed !== this.$store.getters['author/get']('userid'))
      if (!this.$props.items && !(status.loading || status.dragging) && !this.config.status.dropping) {
        this.$set(this.config.status, 'dropping', true)
        this.$set(this.config.status, 'locked', !isAuthed)
      }
    },
    dragleave: function () {
      this.$set(this.config.status, 'dropping', false)
      this.$set(this.config.status, 'locked', false)
    },
    drop: function (e) {
      const { items } = this.$props || {}
      if (
        e &&
        e.dataTransfer &&
        e.dataTransfer.files &&
        e.dataTransfer.files.length
      ) {
        this.upload(e.dataTransfer.files)
      }
    },
    setGhost: function (items) {
      if (items && items.length) {
        if (
          items.length === 1 &&
          items[0].name
        ) {
          this.$set(this.store, 'ghost', items[0].name)
        } else if (items.length > 0) {
          this.$set(this.store, 'ghost', items.length + '項目')
        } else {
          this.$set(this.store, 'ghost', 'Error')
        }
      }
    }
  },
  computed: {
    isSimple () {
      return !!this.$props.items
    },
    requireOnlyItems () {
      return !!this.$props.showOnlyItems
    },
    isLoading () {
      return this.config.status.loading
    },
    isDropping () {
      return this.config.status.dropping
    },
    isLocked () {
      return this.config.status.locked
    },
    isSetClientId () {
      return (this.$props.cid || this.$route.params.id)
    },
    getClientId () {
      return !this.$props.cid ? this.$route.params.id : this.$props.cid
    },
    getStatus () {
      return this.config.status
    },
    getLibrary () {
      return this.store.lib
    },
    getItems () {
      let items = !this.$props.items ? this.store.items : this.$props.items
      return items.map(it => {
        if (it.name && it.type && it.tags) {
          let tags = {}
          for (let i = 0; i < it.tags.length; i++) {
            let tag = it.tags[i].split('=')
            tags[tag[0]] = tag.length > 1 ? tag[1] : true
          }
          return {
            id: it.id,
            name: it.name,
            type: it.type,
            size: it.size,
            modified_at: it.modified_at,
            active: (!(
              this.$props.filters &&
              this.$props.filters.extensions &&
              this.$props.filters.extensions.length &&
              !this.$props.filters.extensions.includes(it.extension)
            ) && !(
              this.$props.filters &&
              this.$props.filters.ids &&
              this.$props.filters.ids.length &&
              this.$props.filters.ids.includes(it.id)
            )) || (it.type === 'folder'),
            tags: tags
          }
        } else {
          return {}
        }
      }).sort((a, b) => {
        if (this.form.order.dir === 'asc') {
          return a[this.form.order.field] > b[this.form.order.field] ? 1 : -1
        } else {
          return a[this.form.order.field] < b[this.form.order.field] ? 1 : -1
        }
      })
    },
    printGhost () {
      return this.store.ghost
    }
  }
}
</script>

<style lang="scss">
.filer {
  .order-link {
    position: relative;
    display: block;
    width: 100%;
    height: $form_h;
    line-height: $form_h;
    text-align: left;
    padding-left: 1rem;
    &.btn {
      outline: 0 !important;
      &:hover {
        background: rgba(#000, .1);
      }
    }
  }
  .items {
    border-top: 1px solid rgba(#000, .12);
    &.dropping {
      border: 1px dashed rgba(#000, .8);
      opacity: .3;
    }
  }
  .ghost {
    position: absolute;
    top: -100%;
    left: -100%;
    border: 1px solid $white;
    border-radius: 2px;
  }
}
</style>
